import axios from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../../constants';

export default function useSaveSearch({ category, userId }) {
  const postSaveSearchActivity = async (query) => {
    return axios
      .post(`${API_BASE_URL}/products/search/activity`, {
        query,
        category,
        action: 'PRODUCT_SEARCH',
        app_os: 'Web',
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
        },
      })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
  };

  const postSaveRecentSearch = async (query) => {
    return axios
      .post(`${API_BASE_URL}/products/search/save`, {
        user_id: userId,
        query,
        category,
      })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
  };

  return {
    postSaveSearchActivity,
    postSaveRecentSearch,
  };
}
